import api from '../api';
import axios from 'axios';
let apiUrl = 'trades';

const state = {
    data: {},
    meta: {}
};

const actions = {
    index: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/${apiUrl}`, config)
            .then((response) => {
                response.config.params?.key ? commit('setByKey', response) : commit('set', response);

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    },

    setByKey(state, response) {
        let key = response.config.params.key;

        if (state.data.hasOwnProperty(key)) {
            state.data[key].meta = response.data.meta;
            state.data[key].links = response.data.links;

            // only append if append_to_list is true
            response.data.data.length
                ? response.config.params?.page && response.config.params?.append_to_list
                    ? state.data[key].data.push(...response.data.data)
                    : (state.data[key].data = response.data.data)
                : (state.data[key].data = []);
        } else {
            state.data[key] = response.data;
        }
    }
};

const getters = {
    get: (state) => {
        return state;
    },
    getById: (state) => (id) => {
        return state.data.find((item) => item.id === id);
    },
    getMeta: (state) => {
        return state.meta;
    },
    getByKey: (state) => (key) => {
        if (state.data && state.data.hasOwnProperty(key)) {
            return state.data[key];
        } else {
            return {
                data: null,
                meta: null,
                links: null
            };
        }
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
